import { type IBuyerMatchQuery } from 'application/querySchemas/IBuyerMatchQuery';
import { type IBuyerUserTokenRepository } from 'application/repositorySchemas/IBuyerUserTokenRepository';
import { type IBuyerMatchListClient, IGetResponse } from 'interfaceAdapter/gatewaySchemas/IBuyerMatchListClient';
import { inject, injectable } from 'tsyringe';

@injectable()
export class BuyerMatchQuery implements IBuyerMatchQuery {
    constructor(
        @inject('IBuyerUserTokenRepository')
        public readonly buyerUserToken: IBuyerUserTokenRepository,
        @inject('IBuyerMatchListClient')
        public readonly buyerMatchListClient: IBuyerMatchListClient,
    ) {}

    public async fetchList(): Promise<IGetResponse['data']> {
        const { data, message } = await this.buyerMatchListClient.get({
            token: this.buyerUserToken.get() || '',
        });
        if (message) {
            throw new Error(message);
        }
        return data;
    }
}
